<template>
  <div
    class="index"
    :class="{
      'index_mobile': isMobile,
      'index_extra-mobile': isExtraMobile,
    }"
  >
    <div class="index__header">
      <div class="index__header-wrap">
        <div class="index__header-left">
          <div class="index__logo">
            <v-icon>mdi-bullseye-arrow</v-icon>
            <span class="index__logo-text">uday.club</span>
          </div>
        </div>
        <div class="index__header-right">
          <v-btn
            text
            :to="{name: 'login'}"
            elevation="0"
          >{{ $t('msg.login') }}</v-btn>
          <v-btn
            class="ml-3 index__btn-registration"
            color="primary"
            :to="{name: 'registration'}"
            @click="eventRegStart"
            elevation="0"
          >{{ $t('msg.registration') }}</v-btn>
        </div>
      </div>
    </div>
    <div class="index__content">
      <slide
        image="/images/index/diary.png"
        :small-images="['/images/index/diary_mob.png']"
      >
        <div class="slide__title">Веб-ежедневник</div>
        <div class="slide__article">Этот многофункциональный сервис поможет Вам повысить уровень жизни за счет упраления:</div>
        <div class="slide__mark"><v-icon>mdi-check</v-icon>верменем</div>
        <div class="slide__mark"><v-icon>mdi-check</v-icon>действиями</div>
        <div class="slide__mark"><v-icon>mdi-check</v-icon>финансами</div>
        <div class="slide__article">Так же найдете единомышленников и все это под контролем "электронного" куратора.</div>
        <div style="margin-top: 40px;">
          <btn-registration
            title="Попробовать"
            @click="eventRegStart"
          ></btn-registration>
        </div>
      </slide>
      <div class="index__sub-title index__sub-title_white">Основные возможности</div>
      <cells
        :items="cells"
      ></cells>
      <div class="d-flex justify-center index__bg-white pa-6">
        <btn-registration @click="eventRegStart"></btn-registration>
      </div>

      <div class="index__sub-title">Цели и планирование</div>

      <div class="index__desc-wrap">
        <div class="index__desc">
          <div class="index__desc-item">Список целей и планирование позволяют не забыть свой вектор движения и выбирать правильные задачи на день/неделю/месяц.</div>
          <div class="index__desc-item">Ежедневник помогает Вам держать нужное в фокусе.</div>
        </div>
      </div>

      <slide
        image="/images/index/targets.png"
        :small-images="['/images/index/targets_mob.png']"
        title="Дневник целей"
        :strings="[
          'Хронологический порядок целей.',
          'Наглядный график целей.',
          'Мониторинг выполнения целей.',
        ]"
      ></slide>

      <slide
        image="/images/index/projects.png"
        :small-images="['/images/index/projects_mob.png']"
        white
        right
        title="Проекты"
        :strings="[
          'Создание и ведение проектов.',
          'Поддержка маркеров с изменяемыми цветами. Позволяет визуально выделить проект, задачу и др. в сервисе.',
          'Выделение важных проектов цветом.',
        ]"
      ></slide>

      <slide
        image="/images/index/project_tasks.png"
        :small-images="['/images/index/project_tasks_mob.png']"
        title="Задачи"
        :strings="[
          'Создание и ведение задач в проектах.',
          'Ручная сортировка задач.',
          'Поддержка подзадач.',
          'Примерное затраченное время и дата выполнения.',
          'Напоминание задачи: одноразовое, каждый день, каждую неделю, каждый месяц, каждый год. С указанием времени.',
        ]"
      ></slide>

      <slide
        image="/images/index/project_diary.png"
        :small-images="['/images/index/project_diary_mob.png']"
        white
        right
        title="Дневник цели"
        :strings="[
          'Ведение дневника цели.',
          'Каждая запись в дневнике цели привязана ко дню создания (1 день, 10 день проекта и др.)',
          'При публикации цели другие пользователи могут следить за вашими действиями и результатами.',
        ]"
      ></slide>

      <slide
        image="/images/index/project_report.png"
        :small-images="['/images/index/project_report_mob.png']"
        title="Статистика"
        :strings="[
          'Отчет по задачам проекта за любой период.',
          'Позволяет сделать анализ затраченного времени на проект.',
        ]"
      ></slide>

      <div class="ma-8 d-flex justify-center">
        <btn-registration @click="eventRegStart"></btn-registration>
      </div>

      <div class="index__sub-title index__sub-title_white">Дневник</div>

      <slide
        image="/images/index/diary.png"
        :small-images="['/images/index/diary_mob.png']"
        white
        right
        :strings="[
          'Распределение задач на месяц, неделю, день.',
          'Напоминание по задачам на день.',
          'Ближайшие цели всегда на виду.',
          'Дневной отчет.',
          'Результатом постоянного ведения дневника получится основа автобиографии.'
        ]"
      ></slide>

      <div class="pa-8 d-flex justify-center index__bg-white">
        <btn-registration @click="eventRegStart"></btn-registration>
      </div>

      <div class="index__sub-title">Финансы</div>

      <slide
        image="/images/index/finance_accounts.png"
        :small-images="['/images/index/finance_accounts_mob.png']"
        title="Счета"
        :strings="[
          'Создание и ведение счетов.',
          'Поддержка разных валют.',
          'Все счета в одном месте позволяют легко оценить финансовую ситуацию.'
        ]"
      ></slide>

      <slide
        image="/images/index/finance_groups.png"
        :small-images="['/images/index/finance_groups_mob.png']"
        white
        right
        title="Группы расходов/доходов"
        :strings="[
          'Создание групп расходов (продукты, бензин, квартплата, разное и др.) и доходов (зарплата, кешбэк, проценты по вкладу, прибыль со своего проекта и др.).',
          'Поддержка разных валют.',
          'Отчет по доходам и расходам по группам, например, за месяц.',
        ]"
      ></slide>

      <slide
        image="/images/index/finance_transactions.png"
        :small-images="['/images/index/finance_transactions_mob.png']"
        title="Финансовые операции"
        :strings="[
          'Записи операций по доходам и расходам.',
          'Поддержка перевода со счета на счет.',
          'Поддержка перевода с конвертацией валюты.',
          'Отчет по доходам и расходам.',
        ]"
      ></slide>

      <slide
        image="/images/index/finance_month_report.png"
        :small-images="['/images/index/finance_month_report_mob.png']"
        white
        right
        title="Месячный бюджет"
        :strings="[
          'Планирование месячного бюджета по доходам, расходам, переводам (например, для накопления денег на определенном счете).',
          'Наглядно видно планируемый бюджет и фактический по расходам и доходам.',
        ]"
      ></slide>

      <div class="pa-8 d-flex justify-center index__bg-white">
        <btn-registration @click="eventRegStart"></btn-registration>
      </div>

      <div class="index__sub-title">Нетворкинг</div>

      <slide
        image="/images/index/feed.png"
        :small-images="['/images/index/feed_mob.png']"
        :strings="[
          'Следите за опубликованными проектами других пользователей.',
          'Общайтесь с единомышленниками в комментариях.',
          'Подписывайтесь на дневники целей других пользователей.',
        ]"
      ></slide>

      <slide
        image="/images/index/chat.png"
        :small-images="['/images/index/chat_mob.png']"
        white
        right
        :strings="[
          'Сервис постоянно дорабатывается, если функционала не хватает, напишите куратору в чат.',
          'По любым вопросам всегда можете написать куратору. Вам обязательно помогут.',
        ]"
      ></slide>

      <div class="pa-8 d-flex justify-center index__bg-white">
        <btn-registration @click="eventRegStart"></btn-registration>
      </div>

      <div class="index__sub-title">Стоимость</div>

      <div class="index__packages mt-8">
        <packages
          action="loadPackages"
          with-out-btns
        ></packages>
      </div>

      <div class="pa-8 d-flex justify-center">
        <btn-registration @click="eventRegStart" :title="$t('msg.tryForFree')"></btn-registration>
      </div>

      <new-features
        title="Ближайшие функции которыми будет дополнен сервис"
        :items="newFeatures"
        class="index__bg-white"
      ></new-features>

    </div>

    <div class="index__footer">
      <div class="index__footer-wrap">
        <div class="index__footer-left">
          <div class="index__logo">
            <v-icon>mdi-bullseye-arrow</v-icon>
            <span class="index__logo-text">uday.club</span>
          </div>
        </div>
        <div v-if="!isExtraMobile" class="index__email">
          <a href="mailto:info@uday.club">info@uday.club</a>
        </div>
        <div class="index__footer-right">
          <div v-if="isExtraMobile" class="index__email">
            <a href="mailto:info@uday.club">info@uday.club</a>
          </div>
          <a href="https://t.me/ivan_p_2" target="_blank" class="index__telegram-link">
            <div class="mr-3">Написать в Telegram</div>
            <img class="index__telegram" src="/images/icons/telegram-white.svg">
          </a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Slide from "@/components/ui/Slide";
import BtnRegistration from "@/components/ui/BtnRegistration";
import Cells from "@/components/ui/Cells";
import NewFeatures from "@/components/ui/NewFeatures";
import Packages from "@/components/block/Billing/Packages";

export default {
  components: {Slide, BtnRegistration, Cells, NewFeatures, Packages},
  data() {
    return {
      cells: [
        {
          title: 'Цели',
          icon: 'mdi-bullseye-arrow',
          strings: [
            'Создание и ведение списка целей.',
            'Возможность делиться своими целями и действиями к их достижению с другими пользователями.',
            'Изучение опубликованных цели других пользователей.',
          ],
        },
        {
          title: 'Планирование',
          icon: 'mdi-clipboard-check-outline',
          strings: [
            'Планирование от общего к часному: цель > общий план > план на месяц > план на неделю > план на день.',
            'Ведение проектов.',
            'Эффективное управление задачами.'
          ],
        },
        {
          title: 'Финансы',
          icon: 'mdi-currency-usd',
          strings: [
            'Планирование месячного бюджета.',
            'Запись финансовых операций (доходы, расходы, переводы).',
            'Отчет по доходам и расходам.',
          ],
        },
        {
          title: 'Дневник',
          icon: 'mdi-notebook-outline',
          strings: [
            'Аналог бумажного ежедневника.',
            'Распределение задач на месяц, неделю, день.',
            'Отчеты по затраченному времени за день.',
            'Напоминания.',
          ],
        },
        {
          title: 'Куратор',
          icon: 'mdi-account-outline',
          strings: [
            'Помогает придерживаться выбранного вектора движения.',
            'Напоминает о важных проектах и задачах.',
          ],
        },
        {
          title: 'Мультиплатформенность',
          icon: 'mdi-cellphone-link',
          strings: [
            'Сервис всегда под рукой и работает на разных устройствах: телефонах, планшетах и компьютерах.',
            'Оповещения в Telegram бот.',
          ],
        },
      ],
      newFeatures: [
        {
          title: 'Функционал для выработки новых привычек и избавления от плохих',
          date: '2023-04-01',
        },
        {
          title: 'Отчет по финансам в виде графиков',
          date: '2023-05-01',
        },
        {
          title: 'Отчет по проектам и задачам в виде графиков',
          date: '2023-05-16',
        },
        {
          title: 'При составлении планов на неделю и месяц возможность переноса задач с прошлого периода',
          date: '2023-06-01',
        },
        {
          title: 'Обучение по использованию сервиса',
          date: '2023-07-01',
        },
        {
          title: 'Информирование о невыполненных задачах за прошедшие дни, чтобы не забыть о них',
          date: '2023-07-16',
        },
        {
          title: 'Кнопка "На год назад" чтобы посмотреть что было в этот день в дневнике год назад',
          date: '2023-08-01',
        },
      ],
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isExtraMobile() {
      return this.$vuetify.breakpoint.xs;
    },
  },
  methods: {
    eventRegStart() {
      if (process.env.NODE_ENV !== 'development') {
        ym(92218980,'reachGoal','reg_start');
      }
    }
  },
  created() {
    this.$store.commit('setUtm', this.$route.query);
  }
}
</script>

<style lang="scss">
$maxWidth: 1300px;

.index {
  &.index_mobile {
    &.index_extra-mobile {
      .index__header-right {
        justify-content: center;
        display: flex;
        flex-direction: column;
      }
      .index__btn-registration {
        margin-left: 0 !important;
      }
      .index__footer-right {
        flex-direction: column;
        align-items: flex-end;
      }
      .index__email {
        margin-bottom: 10px;
      }
      .index__telegram-link {
        div:first-child {
          text-align: end;
          margin-left: 12px;
        }
      }
      .index__logo-text {
        font-size: 28px;
      }
    }
  }
  .index__header {
    background-color: #fff;
    display: flex;
    justify-content: center;
  }
  .index__header-wrap {
    width: $maxWidth;
    max-width: $maxWidth;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 20px;
  }
  .index__header-right {
    font-family: Nunito;
  }
  .index__logo {
    display: flex;
    align-items: center;
    color: #62708f;

    .v-icon {
      font-size: 50px;
      color: #62708f;
    }
  }
  .index__logo-text {
    font-size: 30px;
    font-weight: 300;
    margin-left: 10px;
  }
  .index__content {
    font-family: Nunito;
  }
  .index__sub-title {
    display: flex;
    justify-content: center;
    padding: 40px 0 10px 0;
    font-size: 32px;
    font-weight: 300;

    &.index__sub-title_white {
      background-color: #fff;
    }
  }
  .index__desc-wrap {
    display: flex;
    justify-content: center;
  }
  .index__desc {
    max-width: $maxWidth;
    padding: 40px 20px 20px 20px;
    font-size: 19px;
    font-weight: 300;
  }
  .index__desc-item {
    text-align: center;
    margin: 5px 0;
  }
  .index__bg-white {
    background-color: #fff;
  }
  .index__footer {
    background-color: #62708f;
    display: flex;
    justify-content: center;
    font-family: Nunito;

    .index__logo {
      color: #fff;

      .v-icon {
        color: #fff;
      }
    }
  }
  .index__footer-wrap {
    width: $maxWidth;
    max-width: $maxWidth;
    padding: 30px 20px;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
  }
  .index__telegram {
    width: 40px;
    height: 40px;
  }
  .index__telegram-link {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #fff;
  }
  .index__footer-right {
    display: flex;
    align-items: center;
  }
  .index__email {
    a {
      text-decoration: none;
      color: #fff;
    }
  }
  .index__packages {
    padding: 0 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    .packages {
      justify-content: center;
    }
  }
}
</style>